<!-- 租宝分成日分成明细-->
<template>
  <div class="daily-detail-container">
    <div
      v-if="!isTaxEffectedBill"
      class="header"
    >
      {{ currentDayBillInfo.date | getMonthDay }}共分成{{ currentDayBillInfo.myClear | formatAmount }}元
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="getData"
    >
      <BillTable
        :data="list"
        :columns="columns"
      />
    </van-list>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import List from 'vant/lib/list';
import BillTable from '@/components/BillTable';
import BillApi from '@/api/bill';
import { getMonthDay, formatAmount } from '@/util/filter';
import STATUS from '@/constants/status';
import { SHARE_MODE } from '@/constants/bill';


export default {
  name: 'DailyBillDetail',
  components: {
    [List.name]: List,
    BillTable,
  },
  filters: {
    getMonthDay,
  },
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      pageNum: 1,
      pageSize: 10,
      list: [],
    };
  },
  computed: {
    ...mapState(['isAgent']),
    ...mapGetters(['isAgentUser']),
    ...mapState('billModule', [
      'customerId',
      'currentPoiBillInfo',
      'currentDayBillInfo',
    ]),
    ...mapGetters('billModule', ['isTaxEffectedBill']),
    columns() {
      const isTaxEffectedBill = this.isTaxEffectedBill;
      const arr = [
        {
          label: '时间',
          prop: 'time',
          minWidth: '70px',
        },
        {
          label: '类型',
          prop: 'type',
          minWidth: '70px',
          formatter(row) {
            switch (row.type) {
            case 0:
              return '退款';
            case 1:
              return '收入';
            case 2:
              return '售转租';
            default:
              return '';
            }
          },
        },
      ];

      if (isTaxEffectedBill) {
        arr.push({
          label: '订单金额(元)',
          minWidth: '110px',
          formatter(row) {
            return formatAmount(row.orderAmount);
          },
        });
      } else {
        arr.push({
          label: '参与分成(元)',
          minWidth: '110px',
          formatter(row) {
            return formatAmount(row.joinDivided);
          },
        });
        arr.push({
          label: this.currentPoiBillInfo.shareMode === SHARE_MODE.STAR ? '基础分成(元)' : '我的分成(元)',
          minWidth: '110px',
          formatter(row) {
            return formatAmount(row.myDivided);
          },
        });
      }
      return arr;
    },
  },
  methods: {
    async getData() {
      const {
        settleUnitId, poiId, billMonth, settleUnitMode,
      } = this.currentPoiBillInfo;
      const {
        date, billDay, tagId, shareMode,
      } = this.currentDayBillInfo;
      const params = {
        customerId: this.customerId,
        shareMode,
        settleUnitId,
        poiId,
        billMonth,
        billDay,
        date,
        tagId,
        settleUnitMode,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.loading = true;
      const res = await BillApi.getDailyBillDetail(params);
      if (res.code === STATUS.SUCCESS && res.data) {
        const { isFinished = true, content } = res.data;
        this.list = this.list.concat(content || []);
        this.finished = isFinished;
        if (!this.finished) {
          this.pageNum += 1;
        }
      } else {
        this.error = true;
      }
      this.loading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.daily-detail-container {
  .header {
    font-size: 28px;
    text-align: left;
    padding: 36px 0 24px 16px;
  }
}
</style>
